<template>
  <div :id="componentId" class="spm1-highlights" :style="{ backgroundColor }">
    <div class="spm1-highlights-grid">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        :class="['spm1-highlight-card', { 'is-link': item.jumpType === 2 }]"
        :style="{ backgroundImage: `url(${item.backgroundImage})` }"
        @click="handleClick(item)"
      >
        <span class="spm1-highlight-title">{{ item.title }}</span>
        <div class="spm1-highlight-bar" :style="{ backgroundColor: item.boxBackgroundColor }"></div>
        <span class="spm1-highlight-content">{{ item.content }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHighlightsGrid',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_5'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      items: [
        {
          title: '第七届中国品牌发展论坛',
          content: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          jumpType: 1,
          linkAddress: '',
          backgroundImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        },
        {
          title: '区域农业品牌年度盛典',
          content: '聚焦区域农业品牌高质量发展，搭建品牌交流与合作平台',
          jumpType: 2,
          linkAddress: 'https://www.example.com/highlight/2',
          backgroundImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        },
        {
          title: '品牌发展报告发布',
          content: '发布年度区域农业品牌发展报告，解读品牌影响力指数',
          jumpType: 1,
          linkAddress: '',
          backgroundImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        },
        {
          title: '年度案例权威推荐',
          content: '精选年度区域农业品牌典型案例，分享品牌建设成功经验',
          jumpType: 2,
          linkAddress: 'https://www.example.com/highlight/4',
          backgroundImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        }
      ]
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return
      window.open(item.linkAddress, '_blank')
    }
  }
}
</script>

<style scoped>
.spm1-highlights {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-highlights-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.spm1-highlight-card {
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 120px;
}

.spm1-highlight-card.is-link {
  cursor: pointer;
}

.spm1-highlight-card.is-link:active {
  opacity: 0.9;
}

.spm1-highlight-title {
  font-size: 13px;
  font-weight: bold;
  color: #333;
  text-align: center;
  line-height: 18px;
}

.spm1-highlight-bar {
  width: 24px;
  height: 4px;
  border-radius: 2px;
  margin: 8px 0;
}

.spm1-highlight-content {
  font-size: 11px;
  color: #666;
  text-align: center;
  line-height: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
